document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.search-filters__product-item:not([data-labels-injected])').forEach(async (card) => {
      card.setAttribute('data-labels-injected', 'true');

      const link = card.querySelector('a.search-filters__product-link');
      if (!link) return;

      const handle = link.getAttribute('href')?.replace('/products/', '').split('?')[0];
      if (!handle) return;

      try {
        const res = await fetch(`/products/${handle}.js`);
        const product = await res.json();

        // ===== WISHLIST BUTTON =====
        const imageWrapper = card.querySelector(
          '.search-filters__product-image, .search-filters__product-media, a.search-filters__product-link'
        );

        if (imageWrapper && !imageWrapper.querySelector('.wishlist-hero-custom-button')) {
          imageWrapper.style.position = 'relative';

          const variantId = product.variants?.[0]?.id || '';

          const wishlistBtn = document.createElement('div');
          wishlistBtn.className = 'custom-wishlist-btn';

          wishlistBtn.innerHTML = `
            <div
              data-wlh-id="${product.id}"
              data-wlh-link="/products/${handle}?variant=${variantId}"
              data-wlh-variantid="${variantId}"
              data-wlh-price="${(product.price / 100).toFixed(2)}"
              data-wlh-name="${product.title}"
              data-wlh-image="${product.featured_image || ''}"
              class="wishlist-hero-custom-button wishlisthero-quick-view"
              data-wlh-mode="icon_only"
              data-wlh-view="Collection"
            >
              <div>
                <button
                  aria-label="Add to wishlist"
                  title="Add to wishlist"
                  type="button"
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 512 512"
                    width="18"
                    height="18"
                  >
                    <path
                      fill="currentColor"
                      d="M462.3 62.7C407.5 15.2 326.5 24.9 275.7 76.5L256 96.6l-19.7-20.1C185.5 24.9 104.5 15.2 49.7 62.7c-62.8 54.5-66.1 149.8-9.9 207.1l193.5 199.8c6.2 6.4 14.4 9.6 22.7 9.6 8.3 0 16.5-3.2 22.7-9.6l193.5-199.8c56.2-57.3 52.9-152.6-9.9-207.1z"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>

            <style>
              .custom-wishlist-btn {
                position: absolute;
                top: -4px;
                right: -10px;
                z-index: 9;
              }

              .wishlist-hero-custom-button button {
                color: rgb(23, 48, 87);
                background: transparent;
                border-radius: 100%;
                border: none;
                line-height: normal;
                height: 40px;
                display: block;
                padding: 0 12px;
                cursor: pointer;
                opacity: 0.9;
              }

              .wishlist-hero-custom-button svg {
                display: block;
              }
            </style>
          `;

          imageWrapper.appendChild(wishlistBtn);

          // IMPORTANT:
          // Re-init Wishlist Hero after inject
          if (window.WishlistHero && typeof window.WishlistHero.initButtons === 'function') {
            window.WishlistHero.initButtons();
          }
        }

        // ===== LABELS =====
        const labelTags = (product.tags || []).filter(tag => {
          const t = tag.toLowerCase();
          return t.includes('new') || t.includes('pick') || t.includes('%') || t.includes('custom');
        });

        if (!labelTags.length) return;

        const badge = card.querySelector('.search-filters__badge');
        if (!badge) return;

        const labelsHtml = labelTags.map(tag => {
          let text = tag.replace(/label/gi, '').trim().toLowerCase();
          let labelClass = '';

          if (text.includes('pick')) {
            labelClass = 'pick';
          } else if (text.includes('new')) {
            labelClass = 'new';
          } else if (text.includes('custom')) {
            labelClass = 'livepreview';
            text = '<span class="label-desktop">Live Preview</span><span class="label-mobile">Live</span>';
          }

          return `<span class="product-label ${labelClass}">${text || tag}</span>`;
        }).join('');

        badge.innerHTML = `<div class="product-media__labels">${labelsHtml}</div>`;

      } catch (e) {
        console.error('Inject error:', e);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});